// ==============================|| MENU ITEMS - BANNER ROUTES ||============================== //

// icons
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

const TableRoutes = {
  id: 'Table-group',
  title: 'Table Management',
  type: 'group',
  children: [
    {
      id: 'Table-list',
      title: 'Table List',
      type: 'item',
      url: '/table/list',
      icon: FormatListNumberedIcon,
      target: false
    }
  ]
};

export default TableRoutes;
